import React, { useState } from "react";
import useForm from "react-hook-form";
import cep from "cep-promise";

import { Form } from "../../pages/Autocadastro/styles/styles";

// ===========================================================================
// Formulário de ENDEREÇO, com autofill por CEP (cep-promise).
//
// Extraído de pages/Autocadastro/Success.js para ser usado também pela página
// pública de coleta avulsa (/coleta/:token). A única diferença entre os dois
// usos é PARA ONDE o formulário envia — por isso `enviar` é uma prop, e o
// componente não conhece rota nem identifica aluno.
//
// Os 7 campos e a validação são os mesmos que o Banco do Brasil exige para
// registrar boleto (ver modules/boleto.enderecoFaltando na API).
// ===========================================================================
export default function EnderecoForm({ enviar, onPronto, aviso, titulo, rotuloBotao, valores }) {
  const { register, handleSubmit, errors } = useForm();
  const [enviando, setEnviando] = useState(false);
  const [erro, setErro] = useState(null);

  // prefill do que já existe no cadastro (a coleta avulsa manda `valores`)
  const v = valores || {};

  // autofill pelo CEP: mesma mecânica do components/Endereco do portal
  function buscarCEP(valor) {
    const digitos = String(valor || "").replace(/[^0-9]/g, "");
    if (digitos.length !== 8) return;
    cep(digitos)
      .then((dt) => {
        const set = (id, v) => {
          const el = document.querySelector("#" + id);
          if (el && !el.value) el.value = v || "";
        };
        set("AlEndereco", dt.street);
        set("AlBairro", dt.neighborhood);
        set("AlCidade", dt.city);
        set("AlUF", dt.state);
      })
      .catch(() => {
        /* CEP não encontrado: o formando preenche na mão */
      });
  }

  async function onSubmit(data) {
    setEnviando(true);
    setErro(null);
    try {
      // quem chama decide o endpoint: o autocadastro manda p/ /contrato/endereco
      // (identificando o aluno no corpo); a coleta avulsa manda p/ /coleta/:token
      // (o aluno vem de dentro do token). O formulário não sabe a diferença.
      await enviar(data);
      if (onPronto) onPronto();
    } catch (e) {
      const d = e && e.response && e.response.data;
      setErro((d && d.erro) || "Não foi possível salvar seu endereço.");
      setEnviando(false);
    }
  }

  return (
    <Form onSubmit={handleSubmit(onSubmit)}>
      <h1>{titulo || "Só falta o seu endereço."}</h1>
      <p style={{ color: "#555", marginBottom: 15, textAlign: "center" }}>
        {aviso ||
          "Precisamos dele para emitir seus boletos e recibos. Leva menos de um minuto."}
      </p>

      {errors.AlCEP && (
        <span className="errors-autocad">{errors.AlCEP.message}</span>
      )}
      <input
        type="text"
        id="AlCEP"
        name="AlCEP"
        defaultValue={v.AlCEP || ""}
        autoFocus
        placeholder="CEP (apenas números)"
        ref={register({
          required: "Você precisa preencher seu CEP.",
          pattern: {
            value: /^[0-9]{8}$/,
            message: "O CEP precisa ter 8 dígitos numéricos.",
          },
        })}
        onBlur={(e) => buscarCEP(e.target.value)}
      />

      {errors.AlEndereco && (
        <span className="errors-autocad">{errors.AlEndereco.message}</span>
      )}
      <input
        type="text"
        id="AlEndereco"
        name="AlEndereco"
        defaultValue={v.AlEndereco || ""}
        placeholder="Endereço (sem o número)"
        ref={register({ required: "Você precisa preencher seu endereço." })}
      />

      {errors.AlNumero && (
        <span className="errors-autocad">{errors.AlNumero.message}</span>
      )}
      <input
        type="text"
        id="AlNumero"
        name="AlNumero"
        defaultValue={v.AlNumero || ""}
        placeholder="Número"
        ref={register({ required: "Você precisa preencher o número." })}
      />

      {errors.AlComp && (
        <span className="errors-autocad">{errors.AlComp.message}</span>
      )}
      <input
        type="text"
        id="AlComp"
        name="AlComp"
        defaultValue={v.AlComp || ""}
        placeholder="Complemento (casa, ap, bloco...) — opcional"
        ref={register({
          maxLength: {
            value: 14,
            message: "O complemento não pode ter mais de 14 caracteres.",
          },
        })}
      />

      {errors.AlBairro && (
        <span className="errors-autocad">{errors.AlBairro.message}</span>
      )}
      <input
        type="text"
        id="AlBairro"
        name="AlBairro"
        defaultValue={v.AlBairro || ""}
        placeholder="Bairro"
        ref={register({ required: "Você precisa preencher o bairro." })}
      />

      {errors.AlCidade && (
        <span className="errors-autocad">{errors.AlCidade.message}</span>
      )}
      <input
        type="text"
        id="AlCidade"
        name="AlCidade"
        defaultValue={v.AlCidade || ""}
        placeholder="Cidade"
        ref={register({ required: "Você precisa preencher a cidade." })}
      />

      {errors.AlUF && (
        <span className="errors-autocad">{errors.AlUF.message}</span>
      )}
      <input
        type="text"
        id="AlUF"
        name="AlUF"
        defaultValue={v.AlUF || ""}
        maxLength={2}
        placeholder="Estado (UF)"
        ref={register({
          required: "Você precisa preencher o estado.",
          pattern: {
            value: /^[A-Za-z]{2}$/,
            message: "Use a sigla do estado, ex.: RS.",
          },
        })}
      />

      {erro && <span className="errors-autocad">{erro}</span>}

      <button
        type="submit"
        disabled={enviando}
        style={{ width: "100%", padding: 12, marginTop: 4, cursor: "pointer" }}
      >
        {enviando ? "Salvando…" : rotuloBotao || "Continuar"}
      </button>
    </Form>
  );
}
